// ##### 25-04-30 Komarov
import { uniLog } from '../../../server/helpers/uniLog';
import { DEV_MODE_SET, DEV_MODE_UNSET } from '../constants';

export const setDevMode = () => dispatch => {
  // ##### Komarov 2025-09-02
  uniLog('devMode.js', 'axios:src/Redux/actions/setDevMode.js');
  // ##### Komarov 2025-08-26
  try {
    // Ставим cookie на 7 дней
    if (typeof document !== 'undefined') {
      document.cookie = `devMode=1; Path=/; Max-Age=604800`;
    }
  } catch (error) {
    console.error('setDevMode error', error);
  }
  dispatch({
    type: DEV_MODE_SET,
    payload: true,
  });
};
export const unsetDevMode = () => dispatch => {
  // ##### Komarov 2025-09-02
  uniLog('devMode.js', 'axios:src/Redux/actions/unsetDevMode.js');
  try {
    // Удаляем cookie
    if (typeof document !== 'undefined') {
      document.cookie = 'devMode=; Path=/; Max-Age=0';
    }
  } catch (error) {
    console.error('unsetDevMode error', error);
  }
  dispatch({
    type: DEV_MODE_UNSET,
    payload: false,
  });
};
